import DeleteIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ActionModalError from '../../components/_DesignSystemWrappers/Modal/ActionModalError';
import { SITE_CATEGORY } from '../../config/sites';
import actions from '../../modules/sites';
import * as siteSelectors from '../../modules/sites/selectorsTS';
import messages from './messages';

export default function DeleteSiteModal() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const site = useSelector(siteSelectors.getDeleteModalSite);
  const open = useSelector(siteSelectors.getDeleteModalShow);
  const isFetching = useSelector(siteSelectors.getDeleteModalIsFetching);

  const isAcomSite = site?.siteCategory === SITE_CATEGORY.ACCESS_COMMANDER_REMOTE;

  function handleClose() {
    dispatch(actions.deleteSiteHideModal());
  }

  function handleConfirm() {
    dispatch(actions.deleteSiteConfirm(site));
  }

  return (
    <ActionModalError
      icon={<DeleteIcon />}
      isPrimaryButtonDisabled={isFetching}
      isPrimaryButtonLoading={isFetching}
      muiDialogProps={{ maxWidth: 'xs' }}
      onClose={handleClose}
      open={open}
      primaryButtonAction={handleConfirm}
      primaryButtonText={formatMessage(
        isAcomSite ? messages.deleteSiteModalAccessCommanderSubmit : messages.deleteSiteModalConfirm
      )}
      secondaryButtonText={formatMessage(messages.deleteSiteModalCancel)}
      testId="delete-site-modal"
      title={formatMessage(isAcomSite ? messages.deleteSiteModalAccessCommanderTitle : messages.deleteSiteModalTitle, {
        siteName: site?.name,
      })}
    >
      {isAcomSite ? (
        <Typography>
          <FormattedMessage {...messages.deleteSiteModalAccessCommanderText} values={{ siteName: site?.name }} />
        </Typography>
      ) : (
        <>
          <Typography>
            <FormattedMessage {...messages.deleteSiteModalDescriptionTitle} />
          </Typography>
          <ul>
            <Typography component="li">
              <FormattedMessage {...messages.deleteSiteModalDescriptionListOneItem} />
            </Typography>
            <Typography component="li">
              <FormattedMessage {...messages.deleteSiteModalDescriptionListTwoItem} />
            </Typography>
            <Typography component="li">
              <FormattedMessage {...messages.deleteSiteModalDescriptionListThreeItem} />
            </Typography>
          </ul>
          <Typography>
            <FormattedMessage {...messages.deleteSiteModalDescriptionBottom} />
          </Typography>
        </>
      )}
    </ActionModalError>
  );
}
